import { ImageComponent } from 'components/Image';
import { ScrollBlock } from 'components/ScrollBlock';
import { forwardRef } from 'react';
import type { OptionsBlockProps } from '../../types';
import { ScProfileOptions } from './styled';

const MIN_OPTIONS_LIST_HEIGHT = 184;
const MIN_OPTION_HEIGHT = 40;

export const ProfileOptionsBlock = forwardRef<
  HTMLDivElement,
  OptionsBlockProps
>(
  (
    {
      options,
      selectedOption,
      onChange,
      maxHeight,
      addons,
      hideEmptyText,
      minOptionHeight = MIN_OPTION_HEIGHT,
      ...props
    },
    forwardedRef
  ) => (
    <ScProfileOptions {...props} ref={forwardedRef}>
      <div className="border" />
      <div className="content">
        {options.length === 0 ? (
          hideEmptyText ? null : (
            <ul className="options-list">
              <li className="not-found">Not found</li>
            </ul>
          )
        ) : (
          <ScrollBlock
            style={{
              height:
                typeof maxHeight === 'number'
                  ? `${maxHeight}px`
                  : options.length >= 6
                    ? `${MIN_OPTIONS_LIST_HEIGHT}px`
                    : `${
                        options.length * minOptionHeight +
                        (options.length - 1) * 4 +
                        12
                      }px`,
              width: '100%',
            }}
          >
            <ul className={'options-list'}>
              {options.map(({ icon, name, value }, index) => (
                <li
                  className={`${
                    selectedOption?.value === value && 'active'
                  } ${icon != null && 'with-icon'}`}
                  key={index}
                  onClick={() => onChange(value)}
                  style={{ height: `${minOptionHeight}px` }}
                >
                  {icon && (
                    <ImageComponent
                      alt={`${name}`}
                      height={24}
                      src={icon}
                      width={24}
                    />
                  )}
                  <div className="name">{name}</div>
                </li>
              ))}
            </ul>
          </ScrollBlock>
        )}
        {addons && <div className="addons">{addons}</div>}
      </div>
    </ScProfileOptions>
  )
);
